import { useFormContext } from 'react-hook-form';

import { ServiceNotServicedFormData } from '../RelatedService.schema';
import { CardColumn } from '../RelatedServiceCard';

export const ServiceNotServiced = () => {
  const { watch } = useFormContext<ServiceNotServicedFormData>();

  const formData = watch();

  return (
    <div className="mt-4 flex flex-col gap-6 border-t border-neutral-800 pt-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <CardColumn label="Reason" text={formData.reason} />
      </div>
    </div>
  );
};
